// extracted by mini-css-extract-plugin
export default {"title":"settings-modal_title__az+Mf","footer":"settings-modal_footer__9y9E1","close":"settings-modal_close__9Z8pl"};